import { useState } from "react";
import { getPokeInfo } from "../services/pokemon.js";
import Pokemon from "../components/Pokemon";
import Modal from "../components/Modal";

export default function Home({isLoading, pokes, sliderAmount, setSliderAmount, setPokeAmount, generatePokemon, setGenAmount, setGenTotal, genAmount, setIsRandomized }) {
  const [ pokeId, setPokeId ] = useState("")
  const [ pokeInfo, setPokeInfo ] = useState("")
  const [ eggGroups, setEggGroups ] = useState([])

  const fetchPokeInfo = async (id) => {
    const info = await getPokeInfo(id)
    // console.log(info)
    setEggGroups(info.egg_groups.map((eggGroups)=> eggGroups.name))
    for (let i = 0; i < info.flavor_text_entries.length; i++) {
      // console.log(info.flavor_text_entries[i].language.name)
      if (info.flavor_text_entries[i].language.name === `en`) {
        setPokeInfo(info.flavor_text_entries[i].flavor_text.replace(/[\n\f\r]/g, " ").replace(/\s+/g, " ").trim())
        break;
      } else {
        setPokeInfo(info.flavor_text_entries[0].flavor_text.replace(/[\n\f\r]/g, " ").replace(/\s+/g, " ").trim())
      }
    }
  } //pokemon detail to display english

  const handleClick = (id) => {
    setPokeId(id)
    fetchPokeInfo(id)
  } // handle click for poke icon on home screen

  const handleRandomize = (e) => {
    setIsRandomized(e.target.checked);
  }

  const handleGenerate = () => {
    setPokeAmount(sliderAmount)
    generatePokemon(sliderAmount)
  } // handle generate button for slider

  const handleGenChange = (genTotal, genEnd) => {
    setGenAmount(genTotal)
    setGenTotal(genEnd)
    setSliderAmount(genTotal)
    setPokeAmount(genTotal)
  }
  // handleGenChange will need to be removed once filters are added
  
  
  return (
    <>
      <h1 className="Title">PokéFacts</h1>
      <div className="genContainer">
        <button className="genChange" onClick={() => handleGenChange(151, 151)}>Gen I</button>
        <button className="genChange" onClick={() => handleGenChange(100, 251)}>Gen II</button>
        <button className="genChange" onClick={() => handleGenChange(135, 386)}>Gen III</button>
        <button className="genChange" onClick={() => handleGenChange(107, 493)}>Gen IV</button>
        <button className="genChange" onClick={() => handleGenChange(156, 649)}>Gen V</button>
        <button className="genChange" onClick={() => handleGenChange(72, 721)}>Gen VI</button>
        <button className="genChange" onClick={() => handleGenChange(88, 809)}>Gen VII</button>
        <button className="genChange" onClick={() => handleGenChange(96, 905)}>Gen VIII</button>
        <button className="genChange" onClick={() => handleGenChange(120, 1025)}>Gen IX</button>
      </div>
      <div className="slider">
        <div className="sliderAmount" id="sliderValue">Amount of Pokémon: {sliderAmount} </div>
        <input type="range" min="1" max={genAmount} value={sliderAmount} onChange={(event) => setSliderAmount(parseInt(event.target.value))} className="slider" id="myRange"/>
        <input type="button" value="Generate" onClick={handleGenerate} />
        <label className="randomize" htmlFor="randomize">Randomize</label>
        <input type="checkbox" id="randomize" onChange={handleRandomize}/>
      </div>
      {isLoading ?
        <div className="pokeContainerLoading" >
          <div className="loading">Generating Pokémon...</div>
        </div>:
        <div className="pokeContainer" >
          {pokes.map(pokemon => <Pokemon handleClick={handleClick} key={pokemon.id} id={pokemon.id} poke={pokemon}/>)}
        </div>
      }
      {pokeId && (<Modal poke={pokes.find(pokemon => pokemon.id === pokeId)} key={pokeId} pokeInfo={pokeInfo} eggGroups={eggGroups} onClose={() => setPokeId(null)} /> )}
      <div className="disclaimer">Pokémon and its respective characters are trademarks and copyrights of Nintendo, Game Freak, and The Pokémon Company. This project is not affiliated with, endorsed, sponsored, or specifically approved by Nintendo, Game Freak, or The Pokémon Company and is intended for personal and educational use only.</div>
    </>
  )
}